import React, { useState, useEffect } from 'react';
import { Dialog, AppBar, Toolbar, IconButton, Typography, Slide, Box } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import EmissionMap from './EmissionMap';
import LoadingSpinner from '../LoadingSpinner'; // 引入 LoadingSpinner 元件
import { EmissionService } from '../../application/EmissionService';

const Transition = React.forwardRef((props, ref) => (
    <Slide direction="up" ref={ref} {...props} />
));

const emissionService = new EmissionService();

const EmissionMapDialog = ({ openMap, handleCloseMap, selectedVehicle }) => {
    const [loading, setLoading] = useState(false);
    const [emissionTrail, setEmissionTrail] = useState([]);

    useEffect(() => {
        const fetchEmissionTrail = async () => {
            if (selectedVehicle) {
                setLoading(true); // 設置 loading 為 true
                try {
                    const currentDate = new Date();
                    const month = `${currentDate.getFullYear()}-${String(currentDate.getMonth() + 1).padStart(2, '0')}-01`;
                    const trail = await emissionService.getVehicleEmissionTrail(selectedVehicle, month);
                    setEmissionTrail(trail);
                } catch (error) {
                    console.error('Error fetching emission trail:', error);
                    // 這裡可以添加錯誤處理，例如顯示錯誤訊息
                } finally {
                    setLoading(false); // 設置 loading 為 false
                }
            }
        };

        if (openMap) {
            fetchEmissionTrail();
        }
    }, [openMap, selectedVehicle, emissionService]);

    return (
        <Dialog fullScreen open={openMap} onClose={handleCloseMap} TransitionComponent={Transition}>
            <AppBar sx={{ position: 'relative' }}>
                <Toolbar>
                    <IconButton edge="start" color="inherit" onClick={handleCloseMap} aria-label="close">
                        <CloseIcon />
                    </IconButton>
                    <Typography sx={{ ml: 2, flex: 1 }} variant="h6" component="div">
                        {selectedVehicle ? `${selectedVehicle} 碳排放軌跡` : '碳排放軌跡地圖'}
                    </Typography>
                </Toolbar>
            </AppBar>
            {loading ? (
                <LoadingSpinner />
            ) : (
                <EmissionMap
                    emissionTrail={emissionTrail}
                    selectedVehicle={selectedVehicle}
                />
            )}
        </Dialog>
    );
};

export default EmissionMapDialog;